import React, { type CSSProperties } from 'react';
import Button from '../button/Button';
import './ModalActionButtons.scss';

type ModalActionButtonsProps = {
    disabled?: boolean;
    isLoading?: boolean;
    primaryButtonText?: string;
    secondaryButtonText?: string;
    onAction?: (() => void) | null | undefined;
    onCancel?: (() => void) | null | undefined;
    style?: CSSProperties;
};

export const ModalActionButtons = ({
    disabled,
    isLoading,
    primaryButtonText,
    secondaryButtonText,
    onAction,
    onCancel,
    style
}: ModalActionButtonsProps) => (
    <div
        className="b-modal-action-buttons"
        style={style}
    >
        {onCancel && (
            <Button
                secondaryButton
                text={secondaryButtonText}
                clickHandler={onCancel}
                name={secondaryButtonText}
            />
        )}
        {onAction && (
            <Button
                text={primaryButtonText}
                clickHandler={onAction}
                disabled={disabled}
                isLoading={isLoading}
                name={primaryButtonText}
            />
        )}
    </div>
);
